import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/storage"; // Import compat storage
import { initializeFirestore, memoryLocalCache, getFirestore, doc, getDocFromServer } from "firebase/firestore";
import config from "../firebase-applet-config.json";

// Initialize Firebase (Singleton pattern)
const app = !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();

// Initialize Firestore (Modular)
let db: any;
const databaseId = (config.firestoreDatabaseId && config.firestoreDatabaseId !== "(default)") ? config.firestoreDatabaseId : undefined;

try {
  db = initializeFirestore(app as any, {
    localCache: memoryLocalCache()
  }, databaseId);
} catch (e) {
  db = getFirestore(app as any, databaseId);
}

// Validate connection to Firestore initially
async function testConnection() {
  try {
    await getDocFromServer(doc(db, 'test', 'connection'));
  } catch (error) {
    if (error instanceof Error && error.message.includes('the client is offline')) {
      console.error("Please check your Firebase configuration. The client is offline.");
    }
  }
}
testConnection();

// Initialize Storage (Compat) - Use compat to align with Auth for reliable uploads
const storage = firebase.storage();

export { db, storage };
export const auth = firebase.auth();

export const getSecondaryApp = () => {
  return firebase.initializeApp(config, "SecondaryApp");
}